var codeblock_default = {
  "blockStyleSpacing": "zX70z",
  "codeBlock": "fwBf0 zX70z",
  "renderedInTable": "_63ZTp"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
